export const formatOptions = [
    { type: "datetime", label: "Wednesday, March 04, 2020", value: "EEEE, MMMM dd, yyyy" },
    { type: "datetime", label: "Wednesday, March 04, 2020, 09:55:35", value: "EEEE, MMMM dd, yyyy, HH:mm:ss" },
    { type: "datetime", label: "Wednesday, March 04, 2020, 09:55:35 AM", value: "EEEE, MMMM dd, yyyy, hh:mm:ss a" },
    { type: "datetime", label: "Wednesday, 04 March, 2020", value: "EEEE, dd MMMM, yyyy" },
    { type: "datetime", label: "March 14, 2020", value: "MMMM dd, yyyy" },
    { type: "datetime", label: "14 March, 2020", value: "dd MMMM, yyyy" },
    { type: "datetime", label: "14 Mar 2020", value: "dd MMM yyyy" },
    { type: "datetime", label: "14 Mar 2020, 09:55:35", value: "dd MMM yyyy, hh:mm:ss" },
    { type: "datetime", label: "14-03-2020", value: "dd-MM-yyyy" },
    { type: "datetime", label: "14-03-2020, 09:55:35", value: "dd-MM-yyyy, hh:mm:ss" },
    { type: "datetime", label: "March, 2020", value: "MMMM , yyyy" },
    { type: "datetime", label: "Mar/2020", value: "MMM/yyyy" },
    { type: "datetime", label: "14/03/2020", value: "dd/MM/yyyy" },
    { type: "datetime", label: "14", value: "dd" },
    { type: "datetime", label: "03", value: "MM" },
    { type: "datetime", label: "March", value: "MMMM" },
    { type: "datetime", label: "Wednesday", value: "EEEE" },
    { type: "datetime", label: "2020", value: "yyyy" },
    { type: "datetime", label: "9:55:35 AM", value: "hh:mm:ss a" },
    { type: "datetime", label: "09:55:35", value: "HH:mm:ss" },

    { type: "date", label: "Wednesday, March 04, 2020", value: "EEEE, MMMM dd, yyyy" },
    { type: "date", label: "Wednesday, 04 March, 2020", value: "EEEE, dd MMMM, yyyy" },
    { type: "date", label: "March 14, 2020", value: "MMMM dd, yyyy" },
    { type: "date", label: "14 March, 2020", value: "dd MMMM, yyyy" },
    { type: "date", label: "14 Mar 2020", value: "dd MMM yyyy" },
    { type: "date", label: "14-03-2020", value: "dd-MM-yyyy" },
    { type: "date", label: "March, 2020", value: "MMMM, yyyy" },
    { type: "date", label: "Mar/2020", value: "MMM/yyyy" },
    { type: "date", label: "14/03/2020", value: "dd/MM/yyyy" },
    { type: "date", label: "14", value: "dd" },
    { type: "date", label: "03", value: "MM" },
    { type: "date", label: "March", value: "MMMM" },
    { type: "date", label: "Wednesday", value: "EEEE" },
    { type: "date", label: "2020", value: "yyyy" },

    { type: "time", label: "9:55:35 AM", value: "hh:mm:ss a" },
    { type: "time", label: "09:55:35", value: "HH:mm:ss" }
];

export const defaultFormats = {
    datetime: "dd MMM yyyy 'at' hh:mm:ss",
    date: "dd MMM yyyy",
    time: "hh:mm:ss",
    integer: "",
    boolean: "",
    string: ""
};
